export default __webpack_public_path__ + "static/media/apollo.e74b1e32.png";